import Entity from './entity'

export default class ClassificationType extends Entity<number>{
    name:string;
    text:string;
}